export type SettingDto = {
	calculationSettings: {
		quantityMethod: string;
	};
	currencySettings: {
		primaryCurrency: string;
	};
	ui: {
		languages: string;
		menuBarOrder: string;
	};
	recipeSettings: {
		autoCompleteLanguages: string;
		entryLanguages: string;
	};
};

export const defaultSettingDto = (): SettingDto => {
	return {
		calculationSettings: {
			quantityMethod: 'Mean',
		},
		currencySettings: {
			primaryCurrency: 'USD',
		},
		ui: {
			languages: 'en-US,de-DE,fr-FR,it-IT,es-ES',
			menuBarOrder:
				'Recipe,Menu,MenuPlan,Ingredient,BaseIngredient,Accessory,MasterData,Admin',
		},
		recipeSettings: {
			autoCompleteLanguages: 'en-US,de-DE',
			entryLanguages: 'en-US,de-DE',
		},
	};
};
